import React, { useState } from 'react';
import { AgentListPanel } from './AgentListPanel';
import { AgentDetailsPanel } from './AgentDetailsPanel';
import type { KrybotAgent } from '../../../types/krybot';
import styles from './AgentManagement.module.css';

interface AgentManagerProps {
  onRefresh?: () => void;
}

export const AgentManager: React.FC<AgentManagerProps> = ({ onRefresh }) => {
  const [selectedAgentId, setSelectedAgentId] = useState<string | null>(null);
  const [isCreating, setIsCreating] = useState(false);
  const [currentAgent, setCurrentAgent] = useState<KrybotAgent | null>(null);

  const handleSelectAgent = (agentId: string | null) => {
    setSelectedAgentId(agentId);
    setIsCreating(false);
  };

  const handleCreateNew = () => {
    console.log('Create New Agent button clicked');
    setSelectedAgentId(null);
    setIsCreating(true);
    setCurrentAgent(null);
    console.log('isCreating set to true, selectedAgentId set to null');
  };

  const handleSave = () => {
    setIsCreating(false);
    // If we just created a new agent, select it
    if (currentAgent) {
      setSelectedAgentId(currentAgent.id);
    }
    onRefresh?.();
  };

  const handleCancel = () => {
    setIsCreating(false);
    if (!currentAgent) {
      setSelectedAgentId(null);
    }
  };

  const handleAgentChange = (agent: KrybotAgent | null) => {
    setCurrentAgent(agent);
    if (agent && isCreating) {
      setSelectedAgentId(agent.id);
    }
  };

  return (
    <div className="agent-manager">
      <div className="agent-manager-container">
        <div className="agent-manager-list-panel">
          <AgentListPanel
            selectedAgentId={selectedAgentId}
            onSelectAgent={handleSelectAgent}
            onCreateNew={handleCreateNew}
            onRefresh={onRefresh}
          />
        </div>
        <div className="agent-manager-details-panel">
          <AgentDetailsPanel
            agentId={selectedAgentId}
            isCreating={isCreating}
            onSave={handleSave}
            onCancel={handleCancel}
            onAgentChange={handleAgentChange}
          />
        </div>
      </div>
    </div>
  );
};

